import axios from 'axios';
import { PROVIDER_RECOMMENDATIONS_URL } from '../../../../config';

/**
 * Provider-curated recommendations (Business-plan white-label feature).
 *
 * Section codes returned/accepted by the API: 'recommended_place', 'recommended_food'.
 * Create/update send `place_id`; the backend resolves (find-or-create) the POI and
 * stores it — the FE never deals with point_of_interest_id directly.
 *
 * NOTE: the autocomplete + place-detail endpoints below mirror the meeting-point
 * flow but on a provider-scoped (non-experience) route. Pending backend delivery
 * of that contract.
 */

export function getRecommendations(section, cancelToken) {
	return axios.get(
		PROVIDER_RECOMMENDATIONS_URL + (section ? `?section=${section}` : ''),
		{ cancelToken: cancelToken }
	);
}

export function getRecommendationById(id) {
	return axios.get(PROVIDER_RECOMMENDATIONS_URL + '/' + id);
}

export function createRecommendation({
	name,
	relationType,
	placeId,
	description,
	directions,
	sortOrder
}) {
	return axios.post(PROVIDER_RECOMMENDATIONS_URL, {
		name: name,
		relation_type: relationType,
		place_id: placeId,
		description: description,
		directions: directions,
		sort_order: sortOrder
	});
}

export function updateRecommendation(id, payload) {
	return axios.put(PROVIDER_RECOMMENDATIONS_URL + '/' + id, payload);
}

export function deleteRecommendation(id) {
	return axios.delete(PROVIDER_RECOMMENDATIONS_URL + '/' + id);
}

export function getRecommendationAssets(id) {
	return axios.get(PROVIDER_RECOMMENDATIONS_URL + '/' + id + '/assets');
}

export function uploadRecommendationAsset(id, file) {
	const formData = new FormData();
	formData.append('file', file, file.name);
	return axios.post(
		PROVIDER_RECOMMENDATIONS_URL + '/' + id + '/assets',
		formData
	);
}

export function deleteRecommendationAsset(id, assetId) {
	return axios.delete(
		PROVIDER_RECOMMENDATIONS_URL + '/' + id + '/assets/' + assetId
	);
}

// --- Place picker (provider-scoped autocomplete) — pending backend contract ---

export function fetchRecommendationAutocomplete(searchInput, sessionToken) {
	return axios.post(PROVIDER_RECOMMENDATIONS_URL + '/autocomplete', {
		search_input: searchInput,
		session_token: sessionToken
	});
}

export function getRecommendationPlace(placeId, sessionToken) {
	return axios.get(
		PROVIDER_RECOMMENDATIONS_URL +
			`/place-autocomplete/${placeId}?session_token=${sessionToken}`
	);
}
